import { GoList } from "@/components/GoList/GoList";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
// You can create a GoListHeader component, or use a generic one
import { ActivityFeedHeader } from "@/components/Page/Header/ActivityFeedHeader";

export const GoListPage = () => {
  useIsAuthenticated();

  const { shopId } = useParams();
  const { setHeaderContent } = useHeaderContext();

  useEffect(() => {
    // You can create a GoListHeader if you want, or use ActivityFeedHeader for now
    setHeaderContent(shopId ? <ActivityFeedHeader shopId={shopId} /> : null);
    return () => setHeaderContent(null);
  }, [setHeaderContent, shopId]);

  return (
    <div className="mx-auto my-20 w-full max-w-[800px] overflow-hidden rounded-xl bg-white p-8 text-gray-900 shadow-lg">
      <GoList />
    </div>
  );
};
